import FieldsModel from '@/Models/Contracts/FieldsModel';
import i18n from '@/Plugins/i18n';
import BudgetProjection from '@/Models/BudgetProjection';
export default class BudgetProjectionEntry extends FieldsModel {
    resource() {
        return 'budget-projection-entries';
    }
    relations() {
        return {
            budgetProjection: BudgetProjection
        };
    }
    get header() {
        return `
            <span class="grid gap-2">
                <span>${i18n.t('general.budget-projection')}</span>
                <span>${moment(this.date).format('MMMM YYYY')}</span>
            </span>
        `;
    }
}
